"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var container = document.getElementById('popup-root');

var Portal = function Portal(props) {
  var children = props.children,
      className = props.className,
      coors = props.coors,
      parent = props.parent;
  var nextProps = {
    className: (0, _classnames["default"])('portal', className)
  };

  if (coors) {
    nextProps.style = {
      left: coors[0],
      top: coors[1]
    };
  }

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", nextProps, children), parent || container);
};

Portal.propTypes = {
  // ownProps
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  parent: _propTypes["default"].node
};
var _default = Portal;
exports["default"] = _default;